const en_purch_quotation = {
    "": "quotation request",
    add: "create quotation request",
    detail: "quotation request detail",
    add_mitra: "create partner quotation request",

    message: {
        cancel_title: "Are you sure you want to cancel the request?",
        cancel_text: "Enter the reason for cancelling the request.",

        reject_title: "Are you sure you want to reject the request?",
        reject_text: "Enter the reason for rejecting the request.",
    },

    error: {
        create: "Failed to create quotation request.",
        edit: "Failed to update quotation request.",

        reject: "Failed to cancel quotation request.",
        approve: "Failed to process PO.",
        done: "Failed to complete quotation request.",
    },

    success: {
        create: "Quotation request created successfully.",
        edit: "Quotation request updated successfully.",

        reject: "Quotation request cancelled successfully.",
        approve: "PO processed successfully.",
        done: "Quotation request completed successfully.",
    },
}

export default en_purch_quotation;